export default __webpack_public_path__ + "static/media/bg.f5ca6c53.svg";